import React, { useEffect } from "react";
import Row from "./Row";
import Counter from "components/Counter";
import { SharedColors, Spinner, SpinnerSize } from "@fluentui/react";
import { useHistory } from "react-router-dom";
import { Berichtstatus } from "enums/berichtStatus";
import { useZod } from "../../../services/api/ApiClient";
import primaryTheme from "../../../themes/primary";
import { useDateRangeFilter } from "../../../components/DateRangeSelector/useDateRangeFilter";

const CounterPerStatusEnTotaal: React.FC = props => {
    const {zodiosHooks} = useZod();
    const {dateRange, dateFilterRange} = useDateRangeFilter();
    const {data, mutate, isLoading} = zodiosHooks.usePostApiabpDashboardstatistiekenstatus();
    const history = useHistory();

    useEffect(() => {
        retrieveData();
    }, [dateFilterRange]);
    const retrieveData = () => {
        const request = {
            datumVan: dateRange.start.toISOString(),
            datumTm: dateRange.end.toISOString(),
        };
        mutate({...request});
    };

    function onClickTotaal(): any {
        history.push("/dico");
    }

    // Helper function to safely navigate to a status page
    const navigateToStatus = (status: Berichtstatus) => () => {
        history.push(`/dico/${status}`);
    };

    return (
      <>
          <Row>
              {isLoading ? (
                <Spinner size={SpinnerSize.large}/>
              ) : (
                <div className="statistiek-alle flex-grow flex-container flex-gap-16">
                    <Counter number={data?.alleBerichten ?? 0} text={"Totaal berichten"}
                             onClick={onClickTotaal}/>
                </div>
              )}
          </Row>
          <Row title="Berichten per status">
              {isLoading ? (
                <Spinner size={SpinnerSize.large}/>
              ) : (
                <div className="statistiek-perstatus flex-grow flex-container flex-gap-16">
                    <Counter
                      number={data?.onbestelbaar ?? 0}
                      text={"Onbestelbaar"}
                      borderBottomColor={(data?.onbestelbaar ?? 0) > 0 ? SharedColors.red10 : primaryTheme.palette.green}
                      onClick={navigateToStatus(Berichtstatus.Onbestelbaar)}
                      popupText={"Het aantal berichten dat door ProcurementHub als onderdeel van de validatie is afkeurd"}
                    />
                    <Counter number={data?.inBehandeling ?? 0}
                             text={"In behandeling"}
                             borderBottomColor={(data?.inBehandeling ?? 0) > 0 ? SharedColors.orange10 : ""}
                             onClick={navigateToStatus(Berichtstatus.InBehandeling)}
                             popupText={"Het aantal berichten dat door ProcurementHub in behandeling is genomen, maar nog niet is bezorgd"}
                    />
                    <Counter number={data?.nietBezorgd ?? 0}
                             text={"Niet bezorgd"}
                             borderBottomColor={(data?.nietBezorgd ?? 0) > 0 ? SharedColors.red10 : primaryTheme.palette.green}
                             onClick={navigateToStatus(Berichtstatus.NietBezorgd)}
                             popupText={"Het aantal berichten dat door ProcurementHub  in behandeling is genomen, maar niet bezorgd kon worden. Handmatige actie is noodzakelijk."}
                    />
                    <Counter number={data?.bezorgd ?? 0}
                             text={"Bezorgd"}
                             borderBottomColor={(data?.bezorgd ?? 0) > 0 ? primaryTheme.palette.green : ""}
                             onClick={navigateToStatus(Berichtstatus.Bezorgd)} 
                             popupText={"Het aantal berichten dat door ProcurementHub  is bezorgd."}
                    />
                    <Counter number={data?.handmatigAfgehandeld ?? 0}
                             text={"Handmatig afgehandeld"}
                             borderBottomColor={(data?.handmatigAfgehandeld ?? 0) > 0 ? SharedColors.orange10 : ""}
                             onClick={navigateToStatus(Berichtstatus.HandmatigAfgehandeld)}
                             popupText={"Het aantal berichten dat door ProcurementHub  in behandeling is genomen, maar niet verwerkt kon worden."}
                    />
                </div>
              )}
          </Row>
      </>
    );
};

export default CounterPerStatusEnTotaal;
